<template>
    <div>
        <div class="top-background-bloc"></div>
        <div class="pro-main-title">
            <div class="pt-5 pb-5 header w-100">
                <h1 class="mx-auto col-11">Votre avis</h1>
            </div>

            <div class="pro-main-container-bloc">
                <iframe :src="url"
                        style="width: 100%; height: 700px;border: none;">
                </iframe>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex"

export default {
    name: "ProReview",
    data() {
        return {
            token: null,
            job: null,
            url: 'https://dahub-io.typeform.com/to/K3v9w1t4#contact_token=',
            commune: null,
            offerName: null,
            category: null,
            concatedOtNames: '',
        }
    },
    computed: {
        ...mapState('pro', ['contact'])
    },
    async created() {
        this.token = this.$route.params.token

        await this.$store.dispatch('pro/fetchContact', this.token)

        let res         = await this.$http.get('professional/first-provider/' + this.token)
        let provider    = res.body.data.provider
        let lastVersion = provider.last_version
        this.concatedOtNames = res.body.data.concatOtNames

        if(this.contact.profession !== null) {
            this.job = this.contact.profession.name
        }

        if(lastVersion !== undefined) {
            if(lastVersion.localisation.commune !== null) {
                this.offerName = lastVersion.name
            }

            if(lastVersion.localisation.category !== null) {
                this.category = lastVersion.category.name
            }

            if(lastVersion.localisation.commune !== null) {
                this.commune = lastVersion.localisation.commune.name
            }
        }

        this.url += this.token + '&mail=' + this.contact.email + '&prenom=' +
            this.contact.first_name + '&nom=' + this.contact.last_name + '&job=' +
            this.job + '&job=' + this.job + '&commune=' + this.commune + '&offer_name=' +
            this.offerName + '&category=' + this.category + '&ot_rattaches=' + this.concatedOtNames
    }
}
</script>